export default __webpack_public_path__ + "static/media/bb.8709fd50.png";